import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// Import Actions
import { logout } from '../../AuthActions';

// Import Selectors
import { getUser } from '../../AuthReducer';
import Loading from '../../../../components/loading';


class LogoutPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.logout(props);
  }

  logout(props) {
    props.dispatch(logout()).then(
      () => {
        this.context.router.history.push('/');
      },
      () => {
        console.log('errrrrr logot');
      },
    );
  }

  render() {
    return (<Loading />);
  }
}

// LogoutPage.need = [() => { return logout(); }];


// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    user: getUser(state),
  };
}

LogoutPage.propTypes = {
  user: PropTypes.shape({
    user_id: PropTypes.string,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
};

LogoutPage.contextTypes = {
  router: PropTypes.object,
};

export default connect(mapStateToProps)(LogoutPage);
